<template>
  <div
    class="board"
    @click.stop=""
  >
    <div>
      <h2 class="board-title">
        <span class="mr-2">
          {{ reservation.departure.alias }}
          {{ reservation.departure.preview ? '' : reservation.departure.name }}
        </span>
        <strong>#{{ reservation.id }}</strong>
      </h2>
      <div class="tabs">
        <template v-if="!$store.state.revocation.id">
          <template v-if="reservation.status != 'expired' && !reservation.cancellation">
            <a
              href="#"
              class="tab"
              @click.prevent="
                $router.push({
                  name: 'reservation_passengers',
                  params: $route.params
                })
              "
              :class="{ active: $route.name == 'reservation_passengers' }"
            >
              DETALLES
            </a>
            <a
              href="#"
              class="tab"
              @click.prevent="
                $router.push({ name: 'reservation_worth', params: $route.params })
              "
              :class="{ active: $route.name == 'reservation_worth' }"
            >
              LIQUIDACION
            </a>
          </template>
          <a
            href="#"
            class="tab"
            @click.prevent="
              $router.push({ name: 'reservation', params: $route.params })
            "
            :class="{
              active: ['reservation_pay', 'reservation'].includes($route.name)
            }"
          >
            SALIDA
          </a>
          <a
            href="#"
            v-if="$route.name == 'reservation_update'"
            class="tab active"
          >
            MODIFICAR
          </a>
        </template>
        <template v-else>
          <a
            href="#"
            class="tab active"
            @click.prevent="tab = 'revocar'"
          >
            REVOCAR PASAJEROS
          </a>
        </template>
      </div>
    </div>
    <div class="position-relative overflow-hidden pt-3">
      <router-view
        :reservation="reservation"
        @close="$router.push({ name: 'reservations' })"
      />
    </div>
  </div>
</template>

<script>
import Detail from './Detail'
import Update from './Update'
import Worth from './Worth'
import Pay from './Pay'

import Success from './modify/Success'
import Rates from './modify/Rates'
import Rooming from './modify/Rooming'
import Init from './modify/Init'

var tabs = { pasajeros: 'Update', liquidacion: 'Worth', pagar: 'Pay' }

export default {
  components: {
    Detail,
    Update,
    Worth,
    Pay,
    'modify-success': Success,
    'modify-rates': Rates,
    'modify-rooming': Rooming,
    'modify-init': Init
  },
  computed: {
    tab: {
      get () {
        if (this.$store.state.modify.id) {
          return 'modify-' + this.$store.state.modify.step
        }
        return this.$route.params.tab && tabs.hasOwnProperty(this.$route.params.tab)
          ? tabs[this.$route.params.tab]
          : tabs.pasajeros
      },
      set (tab) {
        this.$router.push({
          name: 'reservation',
          params: { tab, id: this.$route.params.id }
        })
      }
    },
    reservation () {
      return this.$store.state.reservations.find(
        reservation => reservation.id == this.$route.params.id
      )
    }
  }
}
</script>
